<template>
  <section class="price-section">
    <!-- 调试信息 -->
    <div v-if="!vipPlans || vipPlans.length === 0" style="text-align: center; padding: 20px; color: #666;">
      正在加载价格数据...
    </div>
    
    <div v-else class="price-card">

      
      <!-- 原有的桌面端价格区域 -->
      <div>
        <!-- 新的标题和功能图标区域 -->
        <div class="price-features-header" v-if="!isH5Page">
        <div class="price-main-title-container">
          <h2 class="price-main-title">
            助力跨境卖家高效运营，为您挑选最优 
            <img src="../assets/price/聚宝铺解决方案文字.png" alt="聚宝铺解决方案" class="jbp-text-image">
          </h2>
        </div>

        <div class="features-icons">
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/一键采集上架.png" alt="一键采集上架" class="feature-icon-image">
            </div>
            <span class="feature-text">一键采集上架</span>
          </div>
          
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/日常店铺维护.png" alt="日常店铺维护" class="feature-icon-image">
            </div>
            <span class="feature-text">日常店铺维护</span>
          </div>
          
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/自动核价.png" alt="自动核价" class="feature-icon-image">
            </div>
            <span class="feature-text">自动核价</span>
          </div>
          
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/智能匹配类目.png" alt="智能匹配类目" class="feature-icon-image">
            </div>
            <span class="feature-text">智能匹配类目</span>
          </div>
          
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/自动报名活动.png" alt="自动报名活动" class="feature-icon-image">
            </div>
            <span class="feature-text">自动报名活动</span>
          </div>
          
          <div class="feature-icon-item">
            <div class="feature-icon">
              <img src="../assets/price/批量合规信息.png" alt="批量合规信息" class="feature-icon-image">
            </div>
            <span class="feature-text">批量合规信息</span>
          </div>
        </div>

        <!-- 价格周期选择器 -->
        <div class="pricing-period-selector">
          <div class="period-tabs">
            <button 
              class="period-tab" 
              :class="{ 'active': selectedPeriod === 'monthly' }"
              @click="selectedPeriod = 'monthly'"
            >
              每月
            </button>
            <button 
              class="period-tab" 
              :class="{ 'active': selectedPeriod === 'quarterly' }"
              @click="selectedPeriod = 'quarterly'"
            >
              每季
            </button>
            <button 
              class="period-tab yearly-tab" 
              :class="{ 'active': selectedPeriod === 'yearly' }"
              @click="selectedPeriod = 'yearly'"
            >
              <span>每年</span>
              <span class="yearly-savings-text">按年付费最优惠</span>
            </button>
          </div>
        </div>
        </div>
         <!-- H5专用标题和功能图标区域 -->
         <div v-if="isH5Page" class="h5-features-header">
           <div class="h5-main-title-container">
             <h2 class="h5-main-title">
               助力跨境卖家高效运营，为您挑选最优
             </h2>
             <div class="h5-solution-name">
               <img src="../assets/price/聚宝铺解决方案文字.png" alt="聚宝铺解决方案" class="h5-solution-image">
             </div>
           </div>
           
           <div class="h5-features-icons">
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/一键采集上架.png" alt="一键采集上架" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">一键采集上架</span>
             </div>
             
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/日常店铺维护.png" alt="日常店铺维护" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">日常店铺维护</span>
             </div>
             
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/自动核价.png" alt="自动核价" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">自动核价</span>
             </div>
             
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/智能匹配类目.png" alt="智能匹配类目" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">智能匹配类目</span>
             </div>
             
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/自动报名活动.png" alt="自动报名活动" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">自动报名活动</span>
             </div>
             
             <div class="h5-feature-icon-item">
               <div class="h5-feature-icon">
                 <img src="../assets/price/批量合规信息.png" alt="批量合规信息" class="h5-feature-icon-image">
               </div>
               <span class="h5-feature-text">批量合规信息</span>
             </div>
           </div>
           <!-- H5价格周期选择器 -->
           <div class="h5-pricing-period-selector">
             <div class="h5-period-tabs">
               <button 
                 class="h5-period-tab" 
                 :class="{ 'active': selectedPeriod === 'monthly' }"
                 @click="selectedPeriod = 'monthly'"
               >
                 每月
               </button>
               <button 
                 class="h5-period-tab" 
                 :class="{ 'active': selectedPeriod === 'quarterly' }"
                 @click="selectedPeriod = 'quarterly'"
               >
                 每季
               </button>
               <button 
                 class="h5-period-tab h5-yearly-tab" 
                 :class="{ 'active': selectedPeriod === 'yearly' }"
                 @click="selectedPeriod = 'yearly'"
               >
                 <span>每年</span>
                 <span class="h5-yearly-savings-text">按年付费最优惠</span>
               </button>
             </div>
           </div>
         </div>

         <!-- H5专用整体价格卡片 -->
         <div v-if="isH5Page" class="h5-pricing-container">
          <template v-for="plan in vipPlans" :key="`h5-plan-${plan.id}`">
            <div class="h5-pricing-card">
              <!-- 头部价格区域 -->
              <div class="h5-card-header">
                <div class="h5-plan-name">{{ plan.name }}</div>
                <div class="h5-store-count" v-if="plan.level !== 4">{{ plan.storeCount }}个店铺</div>
                <div class="h5-store-count" v-else>按需定制</div>
                <div class="h5-plan-desc">
                  <template v-if="plan.level === 0">满足小型单店卖家日常需求</template>
                  <template v-else-if="plan.level === 1">适合成长型多店卖家</template>
                  <template v-else-if="plan.level === 2">适合成熟多店运营团队</template>
                  <template v-else-if="plan.level === 3">满足企业店群运营需要</template>
                  <template v-else-if="plan.level === 4">解决企业难题</template>
                </div>
                
                <!-- 价格显示 -->
                <div class="h5-price" v-if="plan.level === 0" style="margin-bottom: 55px;">
                  <div class="h5-price-line">
                    <span class="h5-price-amount">¥0</span><span class="h5-price-unit">/月</span>
                  </div>
                </div>
                <div class="h5-price" v-else-if="plan.level === 4" style="margin-bottom: 67px;">
                  <div class="h5-custom-contact">联系聚宝铺客服</div>
                  <!-- <div class="h5-custom-desc">专享服务,根据定制内容计费</div>
                  <div class="h5-custom-desc">根据需求量身打造</div> -->
                </div>
                <div class="h5-price" v-else>
                  <div class="h5-price-line">
                    <span class="h5-price-amount">¥{{ getPriceForPeriod(plan).price }}</span><span class="h5-price-unit">{{ getPriceForPeriod(plan).unit }}</span>
                  </div>
                  <div class="h5-price-savings">
                    <div class="h5-savings-text" v-if="selectedPeriod === 'yearly' && plan.yearlyPrice">
                      折合{{ Math.round(plan.yearlyPrice / 12) }}/月, 节省{{ Math.round((1 - plan.yearlyPrice / (plan.monthlyPrice * 12)) * 100) }}%
                    </div>
                  </div>
                </div>
                
                <!-- 按钮 -->
                <button class="h5-plan-btn" :class="{ 'h5-btn-free': plan.level === 0, 'h5-btn-custom': plan.level === 4 }" @click="handleButtonClick(plan)">
                  <template v-if="plan.level === 0">立即免费体验</template>
                  <template v-else-if="plan.level === 4">升级咨询</template>
                  <template v-else>立即开通</template>
                </button>
              </div>
              
              <!-- 核心权益 -->
              <div class="h5-benefits-section">
                <div class="h5-section-title" style="margin-top: 10px;">核心权益</div>
                <div class="h5-benefits-content">
                  <template v-if="plan.level === 0">
                    免费体验基础功能,体验智能店铺管理,零成本试用,轻松开启电商之路
                  </template>
                  <template v-else-if="plan.level === 1">
                    新增AI、过滤功能，助力快速成长，普通版能力再升级，功能齐全
                  </template>
                  <template v-else-if="plan.level === 2">
                    企业级功能，灵活扩展，助力企业轻松管理多店铺业务
                  </template>
                  <template v-else-if="plan.level === 3">
                    支持30个店铺，AI优化功能更高效，功能再升级，一对一客服，助力高效运营
                  </template>
                  <template v-else-if="plan.level === 4">
                    专享服务，根据定制内容计费根据，需求量身打造
                  </template>
                </div>
              </div>
              
              <!-- 通用服务 -->
              <div class="h5-services-section" style="margin-bottom: 8px;">
                <div class="h5-section-title">通用服务</div>
                <div class="h5-service-item">
                  <span class="h5-service-label">平台店铺数量:</span>
                  <span class="h5-service-value">
                    <template v-if="plan.level === 4">按需定制</template>
                    <template v-else>{{ plan.storeCount }}个</template>
                  </span>
                </div>
              </div>
              
              <!-- 上架模块 -->
              <div class="h5-module-section" style="margin-bottom: 8px;">
                <div class="h5-section-title">上架模块</div>
                <div class="h5-module-item">
                  <span class="h5-module-label">上架货盘数:</span>
                  <span class="h5-module-value">
                    <template v-if="plan.uploadLimit === null">无限</template>
                    <template v-else-if="plan.level === 4">无限</template>
                    <template v-else>{{ plan.uploadLimit }}/天</template>
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">货盘自动上架:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.palletUpload === 1, 'h5-feature-no': plan.palletUpload === 0 }">
                    {{ plan.palletUpload === 1 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">利润、库存监控:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.stockMonitor === 1, 'h5-feature-no': plan.stockMonitor === 0 }">
                    {{ plan.stockMonitor === 1 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">自定义上架商品库存:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.customUploadStock === 1, 'h5-feature-no': plan.customUploadStock === 0 }">
                    {{ plan.customUploadStock === 1 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">重复上架过滤:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.reuploadFilter === 1, 'h5-feature-no': plan.reuploadFilter === 0 }">
                    {{ plan.reuploadFilter === 1 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">货号过滤:</span>
                  <span class="h5-module-value">
                    <template v-if="plan.skuCodeFilter === 0">❌</template>
                    <template v-else-if="plan.level === 1">10</template>
                    <template v-else-if="plan.level === 2">30</template>
                    <template v-else-if="plan.level === 3">50</template>
                    <template v-else-if="plan.level === 4">按需定制</template>
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">违禁词过滤:</span>
                  <span class="h5-module-value">
                    <template v-if="plan.forbiddenWordsFilter === 0">❌</template>
                    <template v-else-if="plan.level === 1">10</template>
                    <template v-else-if="plan.level === 2">30</template>
                    <template v-else-if="plan.level === 3">50</template>
                    <template v-else-if="plan.level === 4">按需定制</template>
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">上架AI自动匹配类目:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.level >= 2, 'h5-feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">AI图片翻译:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.level >= 2, 'h5-feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : '❌' }}
                  </span>
                </div>
                <div class="h5-module-item">
                  <span class="h5-module-label">AI标题优化:</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.level >= 2, 'h5-feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : '❌' }}
                  </span>
                </div>
              </div>
              
              <!-- 运营业务功能模块 -->
              <div class="h5-module-section" style="margin-bottom: 8px;">
                <div class="h5-section-title">运营业务功能模块</div>
                <div class="h5-module-item">
                  <span class="h5-module-label">12大批量操作功能</span>
                  <span class="h5-module-value" :class="{ 'h5-feature-yes': plan.autoSyncStack === 1, 'h5-feature-no': plan.autoSyncStack === 0 }">
                    {{ plan.autoSyncStack === 1 ? '✅' : '❌' }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div v-else>
        <!-- 头部区域 -->
        <div ref="headersContainer" class="pricing-headers" @scroll="syncScroll('headers')">
          <template v-for="plan in vipPlans" :key="`header-${plan.id}`">
            <div class="plan-header-section">
              <!-- 最受欢迎图片 -->
              <div class="most-popular-badge" v-if="plan.isMostPopular">
                <img src="../assets/price/最受欢迎.png" alt="最受欢迎" class="popular-image">
              </div>
              
              <div class="plan-name">{{ plan.name }}</div>
              
              <!-- 店铺数量信息 -->
              <div class="plan-store-count" v-if="plan.level !== 4">
                <template v-if="plan.level === 0">{{ plan.storeCount }}个店铺</template>
                <template v-else-if="plan.level === 1">{{ plan.storeCount }}个店铺</template>
                <template v-else-if="plan.level === 2">{{ plan.storeCount }}个店铺</template>
                <template v-else-if="plan.level === 3">{{ plan.storeCount }}个店铺</template>
              </div>
              <div class="plan-store-count" v-else>按需定制</div>
              
              <div class="plan-desc" v-if="plan.summary">{{ plan.summary }}</div>
              <div class="plan-desc" v-else>
                <template v-if="plan.level === 0">满足小型单店卖家日常需求</template>
                <template v-else-if="plan.level === 1">适合成长型多店卖家</template>
                <template v-else-if="plan.level === 2">适合成熟多店运营团队</template>
                <template v-else-if="plan.level === 3">满足企业店群运营需要</template>
                <template v-else-if="plan.level === 4">解决企业难题</template>
              </div>
              
              <!-- 价格显示 -->
              <div class="plan-price" v-if="plan.level === 0">
                <span class="price-free">¥0/月</span>
              </div>
              <div class="plan-price" v-else-if="plan.level === 4">
                <div class="custom-contact">联系客服</div>
                <div class="price-custom">专享服务,根据定制内容计费</div>
                <div class="price-custom">根据需求量身打造</div>
              </div>
              <div class="plan-price" v-else>
                <div class="price-current">
                  ¥{{ getPriceForPeriod(plan).price }}{{ getPriceForPeriod(plan).unit }}
                </div>
                <div class="price-savings" v-if="selectedPeriod === 'yearly' && plan.yearlyPrice">
                  <div class="savings-text">
                    折合{{ Math.round(plan.yearlyPrice / 12) }}/月, 节省{{ Math.round((1 - plan.yearlyPrice / (plan.monthlyPrice * 12)) * 100) }}%
                  </div>
                </div>
              </div>
              
              <!-- 按钮 -->
              <button class="plan-btn" :class="{ 'btn-free': plan.level === 0, 'btn-custom1': plan.level === 4 }" @click="handleButtonClick(plan)">
                <template v-if="plan.level === 0">立即免费体验</template>
                <template v-else-if="plan.level === 4">升级咨询</template>
                <template v-else>立即开通</template>
              </button>
            </div>
          </template>
        </div>
        
        <!-- 功能卡片区域 -->
        <div ref="cardsContainer" class="pricing-grid" @scroll="syncScroll('cards')">
          <template v-for="plan in vipPlans" :key="`card-${plan.id}`">
            <div class="pricing-item" :class="{ 'free-plan': plan.level === 0 }">
            
            <!-- 核心权益 -->
            <div class="plan-benefits">
              <div class="benefits-title">核心权益</div>
              <div class="benefits-content">
                <template v-if="plan.level === 0">
                  免费体验基础功能，体验智能店铺管理，零成本试用，轻松开启电商之路
                </template>
                <template v-else-if="plan.level === 1">
                  新增AI、过滤功能，助力快速成长，普通版能力再升级，功能齐全
                </template>
                <template v-else-if="plan.level === 2">
                  企业级功能，灵活扩展，助力企业轻松管理多店铺业务
                </template>
                <template v-else-if="plan.level === 3">
                  支持30个店铺，AI优化功能更高效，功能再升级，一对一客服，助力高效运营
                </template>
                <template v-else-if="plan.level === 4">
                  私有部署，按需定制，全面功能，极效服务
                </template>
              </div>
            </div>
            
            <!-- 通用服务 -->
            <div class="plan-services">
              <div class="services-title">通用服务</div>
              <div class="services-grid">
                <div class="service-item">
                  <span class="service-label">平台店铺数量:</span>
                  <span class="service-value">
                    <template v-if="plan.level === 4">按需定制</template>
                    <template v-else>{{ plan.storeCount }}个</template>
                  </span>
                </div>
                <!-- <div class="service-item">
                  <span class="service-label">子账号:</span>
                  <span class="service-value">
                    <template v-if="plan.level === 0">1</template>
                    <template v-else-if="plan.level === 1">3</template>
                    <template v-else-if="plan.level === 2">10</template>
                    <template v-else-if="plan.level === 3">30</template>
                    <template v-else-if="plan.level === 4">按需定制</template>
                  </span>
                </div> -->
              </div>
            </div>
            
            <!-- 上架模块 -->
            <div class="plan-module">
              <div class="module-title">上架模块</div>
              <div class="module-grid">
                <div class="module-item">
                  <span class="module-label">上架货盘数:</span>
                  <span class="module-value">
                    <template v-if="plan.uploadLimit === null">无限</template>
                    <template v-else-if="plan.level === 4">无限</template>
                    <template v-else>{{ plan.uploadLimit }}/天</template>
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">货盘自动上架:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.palletUpload === 1, 'feature-no': plan.palletUpload === 0 }">
                    {{ plan.palletUpload === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <!-- <div class="module-item">
                  <span class="module-label">图片自动上架:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.imageUpload === 1, 'feature-no': plan.imageUpload === 0 }">
                    {{ plan.imageUpload === 1 ? '✅' : 'x' }}
                  </span>
                </div> -->
                <!-- <div class="module-item">
                  <span class="module-label">监控:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.profitMonitor === 1, 'feature-no': plan.profitMonitor === 0 }">
                    {{ plan.profitMonitor === 1 ? '✅' : 'x' }}
                  </span>
                </div> -->
                <div class="module-item">
                  <span class="module-label">利润、库存监控:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.stockMonitor === 1, 'feature-no': plan.stockMonitor === 0 }">
                    {{ plan.stockMonitor === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">自定义上架商品库存:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.customUploadStock === 1, 'feature-no': plan.customUploadStock === 0 }">
                    {{ plan.customUploadStock === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">重复上架过滤:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.reuploadFilter === 1, 'feature-no': plan.reuploadFilter === 0 }">
                    {{ plan.reuploadFilter === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">货号过滤:</span>
                  <span class="module-value">
                    <template v-if="plan.skuCodeFilter === 0">x</template>
                    <template v-else-if="plan.level === 1">10</template>
                    <template v-else-if="plan.level === 2">30</template>
                    <template v-else-if="plan.level === 3">50</template>
                    <template v-else-if="plan.level === 4">按需定制</template>
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">违禁词过滤:</span>
                  <span class="module-value">
                    <template v-if="plan.forbiddenWordsFilter === 0">x</template>
                    <template v-else-if="plan.level === 1">10</template>
                    <template v-else-if="plan.level === 2">30</template>
                    <template v-else-if="plan.level === 3">50</template>
                    <template v-else-if="plan.level === 4">按需定制</template>
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">上架AI自动匹配类目:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.level >= 2, 'feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">AI图片翻译:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.level >= 2, 'feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">AI标题优化:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.level >= 2, 'feature-no': plan.level < 2 }">
                    {{ plan.level >= 2 ? '✅' : 'x' }}
                  </span>
                </div>
              </div>
            </div>
            
            <!-- 运营业务功能模块 -->
            <div class="plan-module">
              <div class="module-title">运营业务功能模块</div>
              <div class="module-grid">
                <div class="module-item">
                  <span class="module-label">12大批量操作功能</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoSyncStack === 1, 'feature-no': plan.autoSyncStack === 0 }">
                    {{ plan.autoSyncStack === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <!-- <div class="module-item">
                  <span class="module-label">自动库存同步:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoSyncStack === 1, 'feature-no': plan.autoSyncStack === 0 }">
                    {{ plan.autoSyncStack === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">自动核价成本:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoCheckPrice === 1, 'feature-no': plan.autoCheckPrice === 0 }">
                    {{ plan.autoCheckPrice === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">自动调价管理:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoChangePrice === 1, 'feature-no': plan.autoChangePrice === 0 }">
                    {{ plan.autoChangePrice === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">自动报名活动:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoApplyActivity === 1, 'feature-no': plan.autoApplyActivity === 0 }">
                    {{ plan.autoApplyActivity === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">自动下架商品:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.autoDownProduct === 1, 'feature-no': plan.autoDownProduct === 0 }">
                    {{ plan.autoDownProduct === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">JIT&库存管理:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.jitStock === 1, 'feature-no': plan.jitStock === 0 }">
                    {{ plan.jitStock === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">批量传说明书:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.batchUploadManual === 1, 'feature-no': plan.batchUploadManual === 0 }">
                    {{ plan.batchUploadManual === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">批量修改货号:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.batchEditSkuCode === 1, 'feature-no': plan.batchEditSkuCode === 0 }">
                    {{ plan.batchEditSkuCode === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">下载活动数据:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.downActivityData === 1, 'feature-no': plan.downActivityData === 0 }">
                    {{ plan.downActivityData === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">批量合规中心:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.batchComplianceInfo === 1, 'feature-no': plan.batchComplianceInfo === 0 }">
                    {{ plan.batchComplianceInfo === 1 ? '✅' : 'x' }}
                  </span>
                </div>
                <div class="module-item">
                  <span class="module-label">批量添加广告:</span>
                  <span class="module-value" :class="{ 'feature-yes': plan.batchApplyAds === 1, 'feature-no': plan.batchApplyAds === 0 }">
                    {{ plan.batchApplyAds === 1 ? '✅' : 'x' }}
                  </span>
                </div> -->
              </div>
            </div>
            
            <!-- 底部按钮 -->
            <div class="plan-footer">
              <div class="more-features" v-if="plan.level === 4">
                <!-- <a href="#" class="more-link">更多功能</a> -->
              </div>
              <div class="more-features" v-else>
                <!-- <a href="#" class="more-link">更多功能</a> -->
              </div>
                             <button class="plan-btn-bottom" :class="{ 'btn-free': plan.level === 0, 'btn-custom': plan.level === 4 }" @click="handleButtonClick(plan)">
                 <template v-if="plan.level === 0">立即免费体验</template>
                 <template v-else-if="plan.level === 4">升级咨询</template>
                 <template v-else>立即开通</template>
               </button>
               
               <!-- 中间三个套餐下方添加升级咨询文字 -->
               <div v-if="plan.level > 0 && plan.level < 4" style="margin-top: 8px; text-align: center;">
                 <span class="upgrade-link" style="color: #2979ff; cursor: pointer; font-size: 0.9rem;" @click="emit('showCustomerService')">
                   升级咨询
                 </span>
               </div>
            </div>
          </div>
        </template>
      </div>
      </div>
    </div>
    </div>
  </section>

  <!-- 版本对比表格区域 -->
  <section class="version-comparison-section" v-if="vipPlans && vipPlans.length > 0">
    <div class="comparison-toggle" @click="toggleComparison">
      <h3 class="comparison-title">查看各个版本对比 <span class="toggle-icon">{{ isComparisonOpen ? '▲' : '▼' }}</span></h3>
    </div>
    
    <div class="comparison-table-container" v-show="isComparisonOpen">
      <table class="comparison-table">
        <thead>
          <tr>
            <th>TEMU</th>
            <th v-for="plan in vipPlans" :key="`header-${plan.id}`">{{ plan.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>平台店铺数</td>
            <td v-for="plan in vipPlans" :key="`storeCount-${plan.id}`">
              <template v-if="plan.level === 4">按需定制</template>
              <template v-else>{{ plan.storeCount }}个店铺</template>
            </td>
          </tr>
          <tr>
            <td>上架数</td>
            <td>100</td>
            <td>无限</td>
            <td>无限</td>
            <td>无限</td>
            <td>无限</td>
          </tr>
          <tr>
            <td>货盘自动上架</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>图片自动上架</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>利润监控</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>库存监控</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>自定义上架商品库存</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>重复上架过滤</td>
            <td class="feature-no">❌</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>货号过滤</td>
            <td class="feature-no">❌</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>违禁词过滤</td>
            <td class="feature-no">❌</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>自动同步库存</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>自动批量核价</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
           <tr>
            <td>自动调价管理</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>自动报名活动</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>自动下架商品</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>JIT&库存管理</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量上传说明书</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量修改货号</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量下载活动数据</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量合规信息</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量参加广告</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
          <tr>
            <td>批量流量加速</td>
            <td class="feature-no">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
            <td class="feature-yes">✅</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, watch } from 'vue'

const props = defineProps({
  vipPlans: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['downloadPlugin', 'showCustomerService'])

// H5页面检测
const isH5Page = ref(false)

// 价格周期选择
const selectedPeriod = ref('monthly')

// 根据选择的周期获取价格
const getPriceForPeriod = (plan) => {
  if (plan.level === 0) {
    // 免费版本始终显示0
    return { price: 0, unit: '/月' }
  }
  if (plan.level === 4) {
    // 定制版本不显示价格
    return null
  }
  
  switch (selectedPeriod.value) {
    case 'monthly':
      return { price: plan.monthlyPrice, unit: '/月' }
    case 'quarterly':
      return { price: plan.quarterlyPrice, unit: '/季' }
    case 'yearly':
      return { price: plan.yearlyPrice, unit: '/年' }
    default:
      return { price: plan.monthlyPrice, unit: '/月' }
  }
}

// 检测是否为H5页面
const checkIsH5Page = () => {
  // 检测用户代理字符串
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  
  // 检测屏幕宽度
  const isSmallScreen = window.innerWidth <= 768
  
  // 检测是否在微信浏览器中
  const isWeChat = /micromessenger/i.test(userAgent)
  
  isH5Page.value = isMobile || isSmallScreen || isWeChat
}

// 本地响应式数据副本，用于前端直接控制isMostPopular字段
const localPlans = ref([])

// 监听vipPlans的变化
watch(() => props.vipPlans, (newPlans) => {
  if (newPlans && newPlans.length > 0) {
    localPlans.value = newPlans.map(plan => {
      return {
        ...plan,
        isMostPopular: plan.level === 2
      }
    })
  }
}, { immediate: true })

onMounted(() => {
  // 检测H5页面
  checkIsH5Page()
  
  // 监听窗口大小变化
  window.addEventListener('resize', checkIsH5Page)
  
  // 复制原始数据并添加isMostPopular字段
  if (props.vipPlans && props.vipPlans.length > 0) {
    localPlans.value = props.vipPlans.map(plan => {
      // 默认将level为2的套餐标记为最受欢迎
      return {
        ...plan,
        isMostPopular: plan.level === 2
      }
    })
  }
})

// 处理按钮点击事件
const handleButtonClick = (plan) => {
  if (plan.level === 4) {
    // 立即咨询 - 调用父组件的客服微信弹窗方法
    emit('showCustomerService')
  } else {
    // 立即体验/立即开通 - 调用父组件的下载插件方法
    emit('downloadPlugin', plan)
  }
}

// 版本对比表格控制
const isComparisonOpen = ref(false)

const toggleComparison = () => {
  isComparisonOpen.value = !isComparisonOpen.value
}

// 同步滚动功能相关代码
const headersContainer = ref(null)
const cardsContainer = ref(null)
const syncing = ref(false)

// 同步滚动函数
const syncScroll = (source) => {
  // 防止循环触发
  if (syncing.value) return
  
  syncing.value = true
  
  try {
    if (source === 'headers' && headersContainer.value && cardsContainer.value) {
      // 从头部滚动到卡片
      const percentage = headersContainer.value.scrollLeft / 
                       (headersContainer.value.scrollWidth - headersContainer.value.clientWidth)
      const cardsScrollLeft = percentage * 
                            (cardsContainer.value.scrollWidth - cardsContainer.value.clientWidth)
      cardsContainer.value.scrollTo({
        left: cardsScrollLeft,
        behavior: 'smooth'
      })
    } else if (source === 'cards' && headersContainer.value && cardsContainer.value) {
      // 从卡片滚动到头部
      const percentage = cardsContainer.value.scrollLeft / 
                       (cardsContainer.value.scrollWidth - cardsContainer.value.clientWidth)
      const headersScrollLeft = percentage * 
                               (headersContainer.value.scrollWidth - headersContainer.value.clientWidth)
      headersContainer.value.scrollTo({
        left: headersScrollLeft,
        behavior: 'smooth'
      })
    }
  } catch (error) {
    console.error('同步滚动出错:', error)
  } finally {
    // 短暂延迟后重置同步标志，避免动画过程中的抖动
    setTimeout(() => {
      syncing.value = false
    }, 100)
  }
}
</script>

<style scoped>
.price-main-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #222;
  position: relative;
}

/* 新增功能图标区域样式 */
.price-features-header {
  margin-bottom: 40px;
  text-align: center;
}

.price-main-title-container {
  margin-top: 40px;
  margin-bottom: 20px;
}

.price-main-title-container .price-main-title {
  color: #333;
  margin-bottom: 0;
  font-size: 2.4rem;
  display: inline-block;
  position: relative;
}

.jbp-text-image {
  vertical-align: middle;
  max-height: 66px;
  margin-top: -12px;
}

.features-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
}

.feature-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}

.feature-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
}

.feature-icon-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.feature-text {
  font-size: 1rem;
  color: #666;
  text-align: center;
  font-weight: 500;
}

/* 价格周期选择器样式 */
.pricing-period-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 40px 0;
  gap: 16px;
  flex-wrap: wrap;
}

.period-tabs {
  display: flex;
  background: #f8f9fa;
  border-radius: 16px;
  padding: 6px;
  gap: 2px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  position: relative;
  overflow: hidden;
}

.period-tab {
  padding: 0;
  border: none;
  background: transparent;
  color: #2979ff;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 200px;
  height: 50px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.period-tab::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #2979ff 0%, #1e88e5 100%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
  z-index: -1;
}

.period-tab.active::before {
  opacity: 1;
}

.period-tab.active {
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 16px rgba(41, 121, 255, 0.25);
  transform: translateY(-1px);
}

.period-tab:hover:not(.active) {
  background: rgba(41, 121, 255, 0.08);
  color: #2979ff;
  font-weight: 700;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(41, 121, 255, 0.15);
}

.period-tab:active {
  transform: translateY(0);
}

.yearly-tab {
  width: 200px;
  height: 50px;
  flex-direction: row;
  gap: 8px;
}

.yearly-savings-text {
  background: #ff6b35;
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.2;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
}

.yearly-tab.active .yearly-savings-text {
  /* 激活状态保持不变，因为背景和颜色已经设置 */
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  transform: translateY(-1px);
}

.yearly-savings-badge {
  background: linear-gradient(135deg, #ff6b35 0%, #f57c00 100%);
  color: #fff;
  padding: 10px 20px;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(255, 107, 53, 0.3);
  position: relative;
  overflow: hidden;
  animation: pulse 2s infinite;
}

.yearly-savings-badge::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 3s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}
/* 价格部分容器样式 */
.price-section {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -30px;
}

.price-card {
  background: transparent;
  border-radius: 24px;
  padding: 40px 48px;
  max-width: 1800px;
  width: 100%;
  text-align: center;
}

/* 新的价格卡片样式 */
.price-main-title {
  font-size: 2.4rem;
  font-weight: bold;
  margin-bottom: 32px;
  color: #222;
  text-align: center;
}

.pricing-headers {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 32px;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.pricing-grid {
    display: flex;
    gap: 24px;
    justify-content: center;
    margin-top: 32px;
    align-items: flex-start;
    flex-wrap: nowrap;
  }

.pricing-item {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1);
  padding: 32px 24px;
  min-width: 200px;
  max-width: 300px;
  flex: 1;
  border: 1px solid #e8f4ff;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.pricing-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(75, 163, 250, 0.2);
}

.free-plan {
  border: 2px solid #e8f4ff;
  background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
}

.custom-plan {
  border: 2px solid #2979ff;
  background: linear-gradient(135deg, #f0f8ff 0%, #fff 100%);
}

.plan-header-section {
  text-align: center;
  padding: 32px 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1);
  min-width: 200px;
  flex: 1;
  max-width: 300px;
  border: 1px solid #e8f4ff;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  /* height: 400px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plan-header-section:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(75, 163, 250, 0.2);
}



.plan-name {
  font-size: 1.4rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.plan-store-count {
  font-size: 1rem;
  font-weight: 600;
  color: #aea01e;
  margin-bottom: 8px;
}

.plan-desc {
  font-size: 0.9rem;
  color: #666;
  /* margin-bottom: 16px; */
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.plan-price {
  /* margin-bottom: 20px; */
  flex: 1;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  min-height: 120px;
}

.price-free {
  font-size: 2.2rem;
  font-weight: bold;
  color: #222;
}

.price-custom {
  font-size: 0.9rem;
  /* font-weight: bold; */
  color: #666;
}

.price-monthly {
  font-size: 2.2rem;
  font-weight: bold;
  color: #0a0a0b;
  margin-bottom: 8px;
}

.price-current {
  font-size: 2.2rem;
  font-weight: bold;
  color: #0a0a0b;
  margin-bottom: 8px;
}

.price-savings {
  margin-top: 8px;
}

.savings-text {
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;
}

.price-yearly {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 4px;
}

.yearly-price-number {
  font-size: 1.2rem;
  color: #2979ff;
  font-weight: 600;
}

.price-save {
  font-size: 0.8rem;
  color: #666;
  font-weight: 500;
}

.plan-btn {
  width: 100%;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #2979ff;
  color: #fff;
  flex-shrink: 0;
  margin-top: auto;
}

.btn-free1 {
  background: #2979ff;
  color: #fff;
  /* border: 2px solid #2979ff; */
  margin-top: 52px;
}

.price-store-info {
  font-size: 0.8rem;
  color: #2979ff;
  margin-top: 8px;
}

.btn-free {
  background: #fff;
  color: #737579;
  border: 2px solid #737579;
}

/* 免费版本按钮特定样式 */
.plan-btn.btn-free {
  margin-top: -5px;
}

.btn-custom1 {
  background: #000;
  color: #fff;
  margin-top: 2px;
}

/* 特别定制版联系文字样式 */
.custom-contact {
  font-size: 1.8rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 15px;
  margin-top: 6px;
}

.btn-custom {
  background: #2979ff;
  color: #fff;
}

/* 功能卡片区域按钮特定样式 */
.plan-btn-bottom.btn-free {
  background: #fff !important;
  color: #737579 !important;
  border: 2px solid #737579 !important;
  margin-bottom: 30px;
}

.plan-btn-bottom.btn-custom {
  background: #000 !important;
  color: #fff !important;
  padding: 12px 32px;
  margin-bottom: 30px;
}

.plan-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(41, 121, 255, 0.3);
}

.plan-benefits,
.plan-services,
.plan-module {
  margin-bottom: 24px;
}

.benefits-title {
  font-size: 1rem;
  font-weight: bold;
  color: #222;
  /* margin-bottom: 12px; */
  padding-bottom: 8px;
  /* border-bottom: 1px solid #e8f4ff; */
}

.services-title,
.module-title {
  font-size: 1rem;
  font-weight: bold;
  color: #222;
  /* margin-bottom: 12px; */
  /* padding-bottom: 8px; */
  /* border-bottom: 1px solid #f0f0f0; */
  text-align: left;
}

.benefits-content {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  height: 4.2em; /* 3行的高度 */
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.services-grid,
.module-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
}

.service-item,
.module-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 6px 0; */
  font-size: 0.85rem;
  gap: 12px;
}

.service-label,
.module-label {
  color: #666;
  flex: 1;
  text-align: left;
}

.service-value,
.module-value {
  color: #222;
  font-weight: 500;
  text-align: right;
  min-width: 40px;
  flex-shrink: 0;
}

.feature-yes {
  color: #4caf50;
  font-weight: bold;
}

.feature-no {
  color: #f44336;
  font-weight: bold;
}

.plan-footer {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.more-features {
  text-align: center;
  margin-bottom: 12px;
}

.more-link {
  color: #2979ff;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}

.more-link:hover {
  text-decoration: underline;
}

.plan-btn-bottom {
  width: 100%;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #2979ff;
  color: #fff;
}

.plan-btn-bottom:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(41, 121, 255, 0.3);
}

/* 最受欢迎徽章样式 */
.most-popular-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}

.popular-image {
  max-width: 100px;
  height: auto;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .pricing-headers {
    gap: 16px;
  }
  .plan-header-section,
  .pricing-item {
    min-width: 200px;
    max-width: 250px;
  }
}

@media (max-width: 1200px) {
  .pricing-headers {
    flex-wrap: wrap;
    justify-content: center;
  }
  .plan-header-section,
  .pricing-item {
    min-width: 200px;
    max-width: 300px;
    flex: 1;
    margin-bottom: 24px;
  }
  .price-main-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  /* 价格周期选择器移动端样式 */
  .pricing-period-selector {
    flex-direction: column;
    gap: 20px;
    margin: 20px 0 30px 0;
    padding: 0 20px;
  }
  
  .period-tabs {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
  }
  
  .period-tab {
    width: 200px;
    height: 50px;
    font-size: 0.9rem;
  }
  
  .yearly-tab {
    width: 200px;
    height: 50px;
  }
  
  .yearly-savings-text {
    font-size: 0.65rem;
    padding: 3px 6px;
    border-radius: 10px;
  }
  
  .yearly-savings-badge {
    font-size: 0.8rem;
    padding: 8px 16px;
    animation: none;
  }
  
  .yearly-savings-badge::before {
    animation: none;
  }

  /* 移动端实现左右滑动效果 */
  .pricing-headers {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    scroll-snap-type: x mandatory;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-bottom: -60px; /* 减小头部区域与功能卡片区域之间的间距 */
  }
  
  /* 隐藏滚动条但保留滚动功能 */
  .pricing-headers::-webkit-scrollbar {
    display: none;
  }
  
  .pricing-headers {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  /* 设置每个头部卡片为固定宽度 */
  .plan-header-section {
    scroll-snap-align: start;
    padding: 20px 14px;
    min-width: 280px;
    max-width: 280px;
    margin-right: 12px; /* 减小卡片之间的间距 */
    flex-shrink: 0;
    height: 380px;
  }
  
  /* 功能卡片区域也实现左右滑动效果 */
  .pricing-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 16px;
    scroll-snap-type: x mandatory;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  
  /* 隐藏功能卡片区域的滚动条 */
  .pricing-grid::-webkit-scrollbar {
    display: none;
  }
  
  .pricing-grid {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  /* 设置每个功能卡片为固定宽度 */
  .pricing-item {
    scroll-snap-align: start;
    padding: 20px 14px;
    min-width: 280px;
    max-width: 280px;
    margin-right: 12px; /* 减小卡片之间的间距 */
    flex-shrink: 0;
  }
  
  .plan-name {
    font-size: 1.2rem;
  }
  
  .price-main-title {
    font-size: 1.8rem;
  }
  
  /* 响应式调整.btn-custom1的margin-top值 */
  .btn-custom1 {
    margin-top: clamp(12px, 2.5vw, 18px);
  }
}

/* 版本对比表格样式 */
.version-comparison-section {
  max-width: 1200px;
  margin: 60px auto 40px;
  width: 100%;
}

.comparison-toggle {
  text-align: center;
  margin-bottom: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.comparison-toggle:hover {
  opacity: 0.8;
}

.comparison-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #222;
  display: inline-block;
  position: relative;
}

.toggle-icon {
  margin-left: 8px;
  font-size: 1.2rem;
  color: #2979ff;
  transition: transform 0.3s ease;
}

.comparison-table-container {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1);
  overflow: hidden;
  /* padding: 24px; */
  margin-top: 16px;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.comparison-table th {
  /* background: #f8f9fa; */
  padding: 16px 12px;
  font-weight: bold;
  color: #222;
  font-size: 0.9rem;
  border-bottom: 2px solid #e8f4ff;
}

.comparison-table th:first-child {
  text-align: left;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  border-bottom: none;
  padding-left: 24px;
  width: 180px;
}

.comparison-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.85rem;
  color: #666;
  vertical-align: middle;
}

.comparison-table td:first-child {
  text-align: left;
  font-weight: 500;
  color: #222;
  padding-left: 24px;
  background: #fff;
  border-right: 1px solid #f0f0f0;
}

.comparison-table tr:last-child td {
  border-bottom: none;
}

.comparison-table tr:hover td:not(:first-child) {
  background: #f8f9fa;
}

/* 响应式版本对比表格 */
@media (max-width: 1200px) {
  .comparison-table-container {
    overflow-x: auto;
  }
  
  .comparison-table {
    min-width: 900px;
  }
}

@media (max-width: 768px) {
  .version-comparison-section {
    margin: 40px auto;
  }
  
  .comparison-title {
    font-size: 1.2rem;
  }
  
  .comparison-table-container {
    padding: 16px;
  }
  
  .comparison-table th,
  .comparison-table td {
    padding: 12px 8px;
    font-size: 0.8rem;
  }
  
  .comparison-table th:first-child,
  .comparison-table td:first-child {
    padding-left: 16px;
  }
}

/* H5专用样式 */
.h5-features-header {
  margin-bottom: 20px;
  text-align: center;
  background: linear-gradient(135deg, #f8fbff 0%, #fff 100%);
  /* padding: 30px 20px; */
  border-radius: 16px;
  /* margin: 20px; */
}

/* H5价格周期选择器样式 */
.h5-pricing-period-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0 20px;
}

.h5-period-tabs {
  display: flex;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 4px;
  gap: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e9ecef;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.h5-period-tab {
  padding: 0;
  border: none;
  background: transparent;
  color: #2979ff;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 70px;
  height: 40px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;
}

.h5-period-tab::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #2979ff 0%, #1e88e5 100%);
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 8px;
  z-index: -1;
}

.h5-period-tab.active::before {
  opacity: 1;
}

.h5-period-tab.active {
  color: #fff;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(41, 121, 255, 0.25);
}

.h5-period-tab:hover:not(.active) {
  background: rgba(41, 121, 255, 0.08);
  color: #2979ff;
  font-weight: 700;
}

.h5-yearly-tab {
  width: 100px;
  height: 40px;
  flex-direction: row;
  gap: 3px;
  padding: 0;
  flex-shrink: 0;
  font-size: 0.75rem;
}

.h5-yearly-savings-text {
  background: #ff6b35;
  color: #fff;
  padding: 1px 4px;
  border-radius: 6px;
  font-size: 0.6rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.2;
  box-shadow: 0 1px 4px rgba(255, 107, 53, 0.3);
}

.h5-yearly-savings-badge {
  background: linear-gradient(135deg, #ff6b35 0%, #f57c00 100%);
  color: #fff;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
}

.h5-main-title-container {
  margin-bottom: 25px;
}

.h5-main-title {
  font-size: 3rem;
  font-weight: bold;
  color: #050404;
  margin-bottom: 15px;
  line-height: 1.4;
}

.h5-solution-name {
  margin-bottom: 0;
  text-align: center;
}

.h5-solution-image {
  max-height: 30px;
  width: auto;
  display: block;
  margin: 0 auto;
}

.h5-features-icons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  max-width: 400px;
  margin: 0 auto;
}

.h5-feature-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  /* padding: 16px 12px; */
  /* background: #fff; */
  /* border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  transition: all 0.3s ease;
}

.h5-feature-icon-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.h5-feature-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.h5-feature-icon-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.h5-feature-text {
  font-size: 0.85rem;
  color: #333;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
}

.h5-pricing-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px 20px 20px 40px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-left: 30px;
}

.h5-pricing-container::-webkit-scrollbar {
  display: none;
}

.h5-pricing-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(75, 163, 250, 0.1);
  overflow: hidden;
  border: 1px solid #e8f4ff;
  min-width: 300px;
  max-width: 300px;
  flex-shrink: 0;
  scroll-snap-align: start;
  height: 700px;
  display: flex;
  flex-direction: column;
}

.h5-card-header {
  padding: 24px 20px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* background: linear-gradient(135deg, #f8fbff 0%, #fff 100%); */
}

.h5-plan-name {
  font-size: 1.5rem;
  font-weight: bold;
  color: #222;
  /* margin-bottom: 8px; */
}

.h5-store-count {
  font-size: 1rem;
  font-weight: 600;
  color: #aea01e;
  /* margin-bottom: 8px; */
}

.h5-plan-desc {
  font-size: 0.9rem;
  color: #666;
  /* margin-bottom: 20px; */
  line-height: 1.4;
}

.h5-price {
  margin-bottom: 20px;
  /* min-height: 100px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.h5-price-line {
  display: inline-block;
  white-space: nowrap;
}

.h5-price-amount {
  font-size: 3rem;
  font-weight: bold;
  color: #222;
  display: inline;
}

.h5-price-unit {
  font-size: 1.2rem;
  color: #666;
  display: inline;
  margin-left: 4px;
}

.h5-yearly-price {
  font-size: 0.9rem;
  color: #666;
  margin-top: 8px;
}

.h5-yearly-amount {
  color: #2979ff;
  font-weight: 600;
}

.h5-save-info {
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
}

.h5-price-savings {
  margin-top: 8px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.h5-savings-text {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
  text-align: center;
}

.h5-custom-contact {
  font-size: 1.8rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
}

.h5-custom-desc {
  font-size: 1rem;
  color: #666;
  margin-bottom: 4px;
}

.h5-plan-btn {
  width: 100%;
  padding: 14px 24px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #2979ff;
  color: #fff;
  margin-top: auto;
  flex-shrink: 0;
}

.h5-btn-free {
  background: #fff;
  color: #737579;
  border: 2px solid #737579;
}

.h5-btn-custom {
  background: #000;
  color: #fff;
}

.h5-plan-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(41, 121, 255, 0.3);
}

.h5-benefits-section {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.h5-section-title {
  font-size: 1rem;
  font-weight: bold;
  color: #222;
  /* margin-bottom: 2px; */
}

.h5-benefits-content {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
}

.h5-service-item,
.h5-module-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 0.85rem;
  border-bottom: 1px solid #f8f8f8;
}

.h5-service-item:last-child,
.h5-module-item:last-child {
  border-bottom: none;
}

.h5-service-label,
.h5-module-label {
  color: #666;
  flex: 1;
  text-align: left;
}

.h5-service-value,
.h5-module-value {
  color: #222;
  font-weight: 500;
  text-align: right;
  min-width: 40px;
  flex-shrink: 0;
}

.h5-feature-yes {
  color: #4caf50;
  font-weight: bold;
}

.h5-feature-no {
  color: #f44336;
  font-weight: bold;
}

.h5-services-section,
.h5-module-section {
  text-align: left;
}

/* H5响应式调整 */
@media (max-width: 480px) {
  .h5-pricing-container {
    padding: 16px;
  }
  
  .h5-card-header {
    padding: 20px 16px;
  }
  
  .h5-plan-name {
    font-size: 1.3rem;
  }
  
  .h5-price-amount {
    font-size: 2.5rem;
  }
  
  .h5-benefits-section,
  .h5-services-section,
  .h5-module-section {
    padding:0 16px;
  }
  
  .h5-pricing-period-selector {
    flex-direction: column;
    gap: 16px;
    margin: 15px 0;
  }
  
  .h5-period-tabs {
    width: 100%;
    /* max-width: 300px; */
    margin: 0 auto;
  }
  
  .h5-period-tab {
    flex: 1;
    width: 60px;
    height: 36px;
    font-size: 0.75rem;
  }
  
  .h5-yearly-tab {
    width: 85px;
    height: 36px;
    font-size: 0.7rem;
  }
  
  .h5-yearly-savings-text {
    font-size: 0.6rem;
    padding: 2px 4px;
  }
  
  .h5-yearly-savings-badge {
    font-size: 0.75rem;
    padding: 5px 10px;
  }
}
</style>